import trace from '~/lib/trace';
import React, {useEffect, useState} from 'react';
import {View} from 'react-native';
import PropTypes from 'prop-types';

import sy from '~/styles';
import {Pressable, Text, ServiceRequestStatusIcon} from '~/components/controls';
import {fleet as fleetApi, rob as robApi} from '~/api/private';
import {REQUEST_TYPES} from '~/types/request';
import {REPLACEMENT_TITLE, ROB_REPLACEMENT_CODE} from '~/types/replacement';

import DirectionsCarIcon from '~/images/md-icons/directions_car/materialicons/24px.svg';
import ListIcon from '~/images/md-icons/list/materialicons/24px.svg';

import {
  hasReplacementVehicleRequest,
  resolveReplacementVehicleSubtitle,
} from '../helper';

const ReplacementVehicleRow = ({request_id, request_type, onPress}) => {
  const [replacementVehicle, setReplacementVehicle] = useState(null);

  useEffect(() => {
    const fetch = async () => {
      let fetchedReplacementVehicle;

      if (request_type === REQUEST_TYPES.FLEET_REQUEST) {
        ({result: fetchedReplacementVehicle} =
          await fleetApi.replacement_vehicle(request_id));
      } else {
        ({result: fetchedReplacementVehicle} = await robApi.replacement_vehicle(
          request_id,
        ));
      }
      setReplacementVehicle(fetchedReplacementVehicle);
    };

    fetch().catch(trace);
  }, [request_id, request_type]);

  let icon = <DirectionsCarIcon fill="#4A4A49" width={24} height={24} />;
  if (hasReplacementVehicleRequest(replacementVehicle)) {
    icon = (
      <ServiceRequestStatusIcon
        status={replacementVehicle.replacement.status}
      />
    );
  }

  const subtitle = resolveReplacementVehicleSubtitle(replacementVehicle);

  return (
    <Pressable
      style={[sy['flex-row'], sy['p-4'], sy['gap-4']]}
      onPress={onPress}>
      {icon}
      <View style={[sy['flex-row'], sy['flex-1'], sy['justify-between']]}>
        {hasReplacementVehicleRequest(replacementVehicle) ? (
          <View>
            {replacementVehicle?.fleet_request ? (
              <Text>Huurauto</Text>
            ) : (
              <Text>
                {ROB_REPLACEMENT_CODE}&nbsp;&middot;&nbsp;{REPLACEMENT_TITLE}
              </Text>
            )}
            <Text style={[sy.small, sy['text-lightgray'], sy.underline]}>
              {subtitle}
            </Text>
          </View>
        ) : (
          <>
            <View>
              <Text>Huurauto</Text>
              <Text style={[sy.small, sy['text-lightgray'], sy.underline]}>
                Keuze maken
              </Text>
            </View>
            <ListIcon fill="#4A4A49" width={24} height={24} />
          </>
        )}
      </View>
    </Pressable>
  );
};
ReplacementVehicleRow.propTypes = {
  request_id: PropTypes.any,
  request_type: PropTypes.any,
  onPress: PropTypes.any,
};

export default ReplacementVehicleRow;
